/**
 * The volume pane is a second lightweight-charts instance under the price
 * chart, synced by logical range. A logical range maps to pixels over the
 * pane's plot width (container width minus the price scale), so the two
 * charts only line up bar for bar when their right price scales are the
 * same width. The price chart's labels (e.g. 25,123.25 + level tags) are
 * wider than the volume labels (1.2K), which stretched the volume pane's
 * bars: same index, different x, drifting further right of the candles
 * towards the live edge.
 *
 * Both charts get minimumWidth = the wider of the two. It only grows: a
 * shrinking minimum would let one scale snap back narrower than the other.
 */
export function sharedPriceScaleWidth(widths: readonly number[], applied: number): number | null {
  const finite = widths.filter((w) => Number.isFinite(w) && w > 0);
  if (finite.length === 0) return null;
  const w = Math.ceil(Math.max(...finite));
  return w > applied ? w : null;
}

/** x of a logical index in a pane `plotWidth` px wide showing `range`. */
export function logicalToX(index: number, range: { from: number; to: number }, plotWidth: number): number {
  const span = range.to - range.from;
  return span > 0 ? ((index - range.from) / span) * plotWidth : 0;
}
